import { i18n } from '@migros/msrc-i18n';
import React from 'react';
export const FrozenPictogram = ({
  pictogram
}) => {
  return /*#__PURE__*/React.createElement("img", {
    src: pictogram,
    alt: i18n.t('components.frozenpictogram.alt'),
    "data-testid": "msrc-articles--frozen-pictogram",
    height: "28px"
  });
};